module.exports = __webpack_public_path__ + "assets/img/mall-item.16c8bd27.png";